import { FC, JSX } from 'react';
import LockIcon from '@mui/icons-material/Lock';
import { useTranslation } from 'react-i18next';
import { useSignOut } from '@consolidocs-ui/components';
import {
  Link,
  Box,
  Typography,
  Sheet,
  CssBaseline,
} from '@mui/joy';

const AccessDenied: FC = (): JSX.Element => {
  const { t } = useTranslation();
  const { signOut } = useSignOut();

  return (
    <>
      <CssBaseline />
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'background.body',
        }}
      >
        <Sheet
          variant="soft"
          sx={{
            p: 4,
            borderRadius: 'lg',
            boxShadow: 'lg',
            maxWidth: 400,
            width: '100%',
            textAlign: 'center',
          }}
        >
          <LockIcon fontSize="large" />
          <Typography level="h3" sx={{ mt: 2 }}>
            {t('Access Denied')}
          </Typography>
          <Typography level="body-sm" sx={{ mt: 1, mb: 3 }}>
            {t(
              'Sorry, you don’t have the necessary permissions to access this page. Try to logout and log back in.'
            )}
          </Typography>
          <Link
            component="button"
            onClick={signOut}
            color="primary"
            underline="hover"
          >
            {t('Logout')}
          </Link>
        </Sheet>
      </Box>
    </>
  );
};

export default AccessDenied;
